import EventBus from "../../../../util/EventBus";
import Applet from "../../Applet";
import PlatformDetailDialog from "../../../../components/PlatformDetailDialog";

class SecondaryPositionFormApplet extends Applet {
    state = {
        Name: "SecondaryPositionFormApplet",
        Actions: {
            View: {
                Groups: [
                    {
                        "identifier": "group1",
                        "type": "standard",
                        "selector": null,
                        "characteristics": [],
                        "membership": [
                            {
                                id: "PositionUSID",
                            }
                        ]
                    }
                ]
            },
            New: {
                Groups: [
                    {
                        "identifier": "group1",
                        "type": "standard",
                        "selector": null,
                        "characteristics": [],
                        "membership": [
                            {
                                id: "PositionUSID",
                            }
                        ]
                    }
                ]
            },
            Edit: {
                Groups: [
                    {
                        "identifier": "group1",
                        "type": "standard",
                        "selector": null,
                        "characteristics": [],
                        "membership": [
                            {
                                id: "PositionUSID",
                            }
                        ]
                    }
                ]
            }
        },
        Layout: {
            totalWidth: "36em",
        },
        Controls: {
            PositionUSID: {
                id: "PositionUSID",
                enterpriseComponentAttribute: "PositionUSID",
                placement: {
                    "View": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "Edit": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "New": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                },
                errors: [
                ],
                csp: {
                    autoFocus: true,
                    multiline: false,
                    placeholder: null,
                    label: "Secondary Position",
                    size: "small",
                    disabled: false,
                },
                ip: {},
                type: "Select",
                requiresConfirmation: false,
            }
        }
    };

    cancel() {
        super.cancel();

        EventBus.components.emit("secondary-position-form-applet-cancel");
    };

    setAction(action) {
        super.setAction(action);

        if (action === "Save Completed") {
            EventBus.components.emit("secondary-position-form-applet-save");
        }
    };

    render() {
        return <PlatformDetailDialog applet={this}
                                layout={this.state.Layout}
                                controls={this.state.Controls}
                                actions={this.state.Actions}
                                title="Secondary Position"
                                enterpriseComponent={this.getEnterpriseComponent()}
                                action={this.props.defaultAction}
                                errorReportingMethod="RealTime" />;
    }
}

export default SecondaryPositionFormApplet;
